import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { DiagnosticProvider } from "@/features/diagnostic/DiagnosticContext";
import Home from "@/pages/Home";
import Diagnostic from "@/pages/Diagnostic";
import ContactStep from "@/pages/ContactStep";
import Careers from "@/pages/Careers";
import Privacy from "@/pages/Privacy";
import AdminPage from "@/pages/admin/AdminPage";

function App() {
  return (
    <DiagnosticProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/assessment/contact" element={<ContactStep />} />
          <Route path="/diagnostic" element={<Diagnostic />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </DiagnosticProvider>
  );
}

export default App;
